module.exports = __webpack_public_path__ + "img/hero-angle-2.8d00f57a.svg";